import {defineMessages} from 'react-intl';

export default defineMessages({
  title: {defaultMessage: 'Lomahaku'},
  title_c: {defaultMessage: 'Kurssihaku'},
  back: {defaultMessage: 'Takaisin'},
  abort: {defaultMessage: 'Keskeytä'},
  continue: {defaultMessage: 'Jatka'},
  cancel: {defaultMessage: 'Peruuta'},
  edit: {defaultMessage: 'Muokkaa'},
  confirm: {defaultMessage: 'Vahvista'},
  print: {defaultMessage: 'Tulosta'},
  send: {defaultMessage: 'Lähetä'},
  save: {defaultMessage: 'Tallenna'},
  search: {defaultMessage: 'Etsi'},
  empty: {defaultMessage: 'Tyhjennä'},
  nothing: {defaultMessage: 'Tyhjä'},
  select: {defaultMessage: 'Valitse'},
  action: {defaultMessage: 'Toiminto'},
  true: {defaultMessage: 'Kyllä'},
  false: {defaultMessage: 'Ei'},
  not: {defaultMessage: 'En'},
  name: {defaultMessage: 'Nimi'},
  eg_phone: {defaultMessage: 'Esim. 0401234567'},
  phone_invalid: {defaultMessage: 'Virheellinen puhelinnumero. Kirjoita puhelinnumero muodossa "0401234567"'},
  exercise_true: {defaultMessage: 'Riittävästi'},
  exercise_false: {defaultMessage: 'Liian vähän'},
  error: {defaultMessage: 'Virhe'},
  header: {defaultMessage: 'Otsikko'},
  subject: {defaultMessage: 'Aihe'},
  adminView: {defaultMessage: 'Tällä sivulla voit muokata hakukalenterin ohjetta ja Lisätiedot-sivun ohjeistusta.'},
  description: {defaultMessage: 'Ohjeistus'},
  close_instructions: {defaultMessage: 'Sulje ohje'},
  primary: {defaultMessage: 'Ensisijainen'},
  holiday: {defaultMessage: 'LOMA'},
  course: {defaultMessage: 'KURSSI'},
  holiday_target: {defaultMessage: 'Lomakohde'},
  course_target: {defaultMessage: 'Kurssikohde'},
  holiday_theme: {defaultMessage: 'Lomateema'},
  course_theme: {defaultMessage: 'Kurssin teema'},
  holiday_time: {defaultMessage: 'Loma-aika'},
  course_time: {defaultMessage: 'Ajankohta'},
  holiday_price: {defaultMessage: 'Omavastuu / vuorokausi'},
  holiday_description: {defaultMessage: 'Kuvaus'},
  holiday_info_title: {defaultMessage: 'Loman tiedot'},
  additional_info: {defaultMessage: 'Lisätiedot'},
  course_info_title: {defaultMessage: 'Kurssin tiedot'},
  holiday_more: {defaultMessage: 'Lisätietoja lomasta'},
  course_more: {defaultMessage: 'Lisätietoja kurssista'},
  instructions: {defaultMessage: 'Ohje'},
  followup: {defaultMessage: 'Jatkojakso'},
  followup_0: {defaultMessage: 'Kurssin toinen jakso:'},
  followup_1: {defaultMessage: 'Kurssin kolmas jakso:'},
  followup_2: {defaultMessage: 'Kurssin neljäs jakso:'},
  followup_3: {defaultMessage: 'Kurssin viides jakso:'},
  date: {defaultMessage: 'Ajankohta'},
  start_date: {defaultMessage: 'Alkamisajankohta'},
  target: {defaultMessage: 'Kohde'},
  theme: {defaultMessage: 'Teema'},
  location: {defaultMessage: 'Kohde'},
  partner: {defaultMessage: 'Yhteistyökumppani'},
  holiday_wishes: {defaultMessage: 'Lomatoiveet'},
  course_wishes: {defaultMessage: 'Kurssitoiveet'},
  selected_wish: {defaultMessage: 'Valitut lomatoiveet: {v}/3'},
  selected_course: {defaultMessage: 'Valitut kurssitoiveet: {v}/3'},
  primary_wish: {defaultMessage: 'Ensisijainen lomatoive'},
  primary_course: {defaultMessage: 'Ensisijainen kurssitoive'},
  search_end_date: {defaultMessage: 'Hakuaika päättyy'},
  remove_wish: {defaultMessage: 'Poista toive'},
  no_wish: {defaultMessage: 'Ei lomatoiveita.'},
  no_course: {defaultMessage: 'Ei kurssitoiveita.'},
  apply_for_holiday: {defaultMessage: 'Täytä hakemus'},
  confirm_holiday1: {defaultMessage: 'Tarkista vielä, että olet valinnut oikeat lomatoiveet!'},
  confirm_course1: {defaultMessage: 'Tarkista vielä, että olet valinnut oikeat kurssitoiveet!'},
  confirm_holiday2: {defaultMessage: 'Täytä hakemus vain kerran, vaikka hakisit useammalle lomalle.'},
  confirm_course2: {defaultMessage: 'Täytä hakemus vain kerran, vaikka hakisit useammalle kurssille.'},
  confirm_holiday3: {defaultMessage: 'Voit valita hakemukselle 1-3 lomatoivetta!'},
  confirm_course3: {defaultMessage: 'Voit valita hakemukselle 1-3 kurssitoivetta!'},
  confirm_holiday_restrictions: {defaultMessage: 'Tarkistathan, että kuulut loman/lomien kohderyhmään'},
  confirm_course_restrictions: {defaultMessage: 'Tarkistathan, että kuulut kurssin/kurssien kohderyhmään'},
  add_wish: {defaultMessage: 'Lisää lomatoive'},
  add_course: {defaultMessage: 'Lisää kurssitoive'},
  applicant_info: {defaultMessage: 'Hakijan tiedot'},
  assistant: {defaultMessage: 'Henkilökohtainen avustaja'},
  assistant_info: {defaultMessage: 'Henkilökohtaisen avustajan tiedot'},
  required: {defaultMessage: 'Täytä tämä kenttä.'},
  fill_all: {defaultMessage: 'Täytä kaikki kentät'},
  min: {defaultMessage: 'Virheellinen arvo. Ole hyvä ja tarkista'},
  max: {defaultMessage: 'Virheellinen arvo. Ole hyvä ja tarkista'},
  minLength: {defaultMessage: 'Virheellinen arvo. Ole hyvä ja tarkista'},
  maxLength: {defaultMessage: 'Teksti liian pitkä ({cur} merkkiä). Ole hyvä ja tarkista.'},
  maxLengthChars: {defaultMessage: 'Max {max} merkkiä'},
  no_decimal: {defaultMessage: 'Ei desimaaleja'},
  no_negative: {defaultMessage: 'Ei negatiivisia lukuja'},
  no_special: {defaultMessage: 'Älä käytä tekstissä merkkejä < tai >'},
  warning_personId: {defaultMessage: "Hakija yli 100-vuotias! Jos ei ole, korjaa hetun välimerkki oikeaksi (2000-luvulla syntyneillä A-kirjain)!"},
  leave_empty: {defaultMessage: 'Jos ei ole, jätä tyhjäksi'},
  email: {defaultMessage: 'Sähköposti:'},
  tel: {defaultMessage: 'Puh:'},
  confirm_email: {defaultMessage: 'Varmista sähköpostiosoite'},
  confirm_email_text: {defaultMessage: 'Anna aikaisemmin syöttämäsi sähköpostiosoite uudelleen.'},
  info_email: {defaultMessage: 'Saat tiedon myönnetystä lomasta sähköpostiisi osoitteesta "{replyEmail}". Muista myös tarkistaa aika ajoin roskapostisi!'},
  info_email_c: {defaultMessage: 'Saat tiedon myönnetystä kurssista sähköpostiisi osoitteesta "{replyEmail}". Muista myös tarkistaa aika ajoin roskapostisi!'},
  edit_application: {defaultMessage: 'Muokkaa hakemusta'},
  vacationers: {defaultMessage: 'Lomalle hakijat'},
  vacationers_c: {defaultMessage: 'Kurssille hakijat'},
  financial: {defaultMessage: 'Taloudelliset tiedot'},
  applicant_income: {defaultMessage: 'Hakijan tulot'},
  euro: {defaultMessage: 'euroa'},
  salary: {defaultMessage: 'ansiotulot'},
  retirementAllowance: {defaultMessage: 'eläketulot'},
  unemploymentAllowance: {defaultMessage: 'työttömyyspäiväraha'},
  investIncome: {defaultMessage: 'pääomatulot'},
  otherAllowance: {defaultMessage: 'sairaus-, äitiys- tms. päiväraha'},
  socialAssistance: {defaultMessage: 'toimeentulotuki'},
  childBenefit: {defaultMessage: 'lapsilisä'},
  childSupport: {defaultMessage: 'elatustuki'},
  housingAllowance: {defaultMessage: 'asumistuki'},
  careAllowance: {defaultMessage: 'omaishoidontuki'},
  otherIncomeBoolean: {defaultMessage: 'muut tulot'},
  debts: {defaultMessage: 'Hakijan velat'},
  total_euro: {defaultMessage: 'yht. euroa'},
  euro_month: {defaultMessage: 'euroa / kk'},
  spouse_income: {defaultMessage: 'Puolison tulot'},
  spouse_debt: {defaultMessage: 'Puolison velat'},
  otherApplicant_income: {defaultMessage: 'Muun samassa taloudessa asuvan hakijan tulot'},
  otherApplicant_debt: {defaultMessage: 'Muun samassa taloudessa asuvan täysi-ikäisen hakijan velat'},
  kid_income: {defaultMessage: 'Lasten tulot: {values}'},
  justification: {defaultMessage: 'Perustelut'},
  min_150: {defaultMessage: 'Perustelujen yhteispituuden pitää olla vähintään 150 merkkiä.'},
  other_info: {defaultMessage: 'Muut tiedot'},
  applicant: {defaultMessage: 'HAKIJA'},
  where_title: {defaultMessage: 'Taustatiedot'},
  abort_confirm: {defaultMessage: 'Haluatko varmasti keskeyttää hakemuksen täyttämisen?'},
  summary: {defaultMessage: 'Yhteenveto'},
  summary_error: {defaultMessage: 'Hakemuksen tallennuksessa tapahtui virhe. Päivitä sivu ja yritä uudelleen.'},
  summary_error_c: {defaultMessage: 'Hakemuksen tallennuksessa tapahtui virhe. Päivitä sivu ja yritä uudelleen.'},
  pdf: {defaultMessage: 'Lomahakemus.pdf'},
  pdf_c: {defaultMessage: 'Kurssihakemus.pdf'},
  basicInfo: {defaultMessage: 'Perustiedot'},
  additionalInfo: {defaultMessage: 'Täydentävät tiedot'},
  financialSituation: {defaultMessage: 'Taloudellinen tilanne'},
  spouse_title: {defaultMessage: 'Puoliso'},
  otherApplicant_title: {defaultMessage: 'Muu samassa taloudessa asuva täysi-ikäinen hakija'},
  kids_title: {defaultMessage: 'Lomalle hakevat lapset'},
  kids_title_c: {defaultMessage: 'Kurssille hakevat lapset'},
  kid: {defaultMessage: 'Lapsi'},
  confidential_statement: {defaultMessage: 'Hakemuksesi käsitellään ehdottoman luottamuksellisesti ja tiedot säilytetään lomajärjestöjen ylläpitämässä rekisterissä. Tietoja käsitellään voimassa olevan henkilötietolain (523/1999) mukaisesti.'},
  confidential_statement_c: {defaultMessage: 'Hakemuksesi käsitellään ehdottoman luottamuksellisesti ja tiedot säilytetään järjestöjen ylläpitämässä rekisterissä. Tietoja käsitellään voimassa olevan henkilötietolain (523/1999) mukaisesti.'},
  confidential_customer_selection: {defaultMessage: 'Asiakasvalinta perustuu STM:n vuosittaiseen valtionavustuspäätökseen ja siinä asetettuihin ehtoihin.'},
  adult_copayment: {defaultMessage: '€ (aikuinen)'},
  child_copayment: {defaultMessage: '€ (lapsi)'},
  personId_invalid: {defaultMessage: 'Virheellinen henkilötunnus'},
  email_invalid: {defaultMessage: 'Virheellinen sähköpostiosoite'},
  zip_invalid: {defaultMessage: 'Virheellinen postinumero'},
  zip_length: {defaultMessage: 'Postinumeron tulee olla 5 merkkiä pitkä'},
  no_emoji: {defaultMessage: 'Hymiöiden käyttäminen lomakkeella ei ole sallittu. Tarkistathan, että tekstisi ei sisällä hymiöitä.'},
  per_month: {defaultMessage: '/kk'},
  OLD_AGE_PENSIONER: {defaultMessage: 'Vanhuuseläkeläinen'},
  DISABILITY_PENSIONER: {defaultMessage: 'Työkyvyttömyyseläkeläinen'},
  EMPLOYEE: {defaultMessage: 'Palkansaaja'},
  ENTREPRENEUR: {defaultMessage: 'Yrittäjä'},
  IN_MATERNITY_LEAVE: {defaultMessage: 'Äitiysvapaalla'},
  IN_PARENTAL_LEAVE: {defaultMessage: 'Vanhempainvapaalla'},
  IN_NURSING_LEAVE: {defaultMessage: 'Hoitovapaalla'},
  IN_FAMILY_LEAVE: {defaultMessage: 'Perhevapaalla'},
  STUDENT: {defaultMessage: 'Opiskelija'},
  UNEMPLOYED: {defaultMessage: 'Työtön'},
  UNABLE_TO_WORK: {defaultMessage: 'Työkyvytön'},
  OTHER: {defaultMessage: 'Muu'},
  SINGLE: {defaultMessage: 'Naimaton'},
  MARRIAGE: {defaultMessage: 'Avioliitto'},
  COHABITATION: {defaultMessage: 'Avoliitto'},
  WIDOW: {defaultMessage: 'Leski'},
  DIVORCED: {defaultMessage: 'Eronnut'},
  JUDICIAL_SEPARATION: {defaultMessage: 'Asuu erillään'},
  SINGLE_PARENT: {defaultMessage: 'Yksinhuoltaja'},
  CO_PARENT: {defaultMessage: 'Yhteishuoltaja'},
  holiday_not_found: {defaultMessage: 'Lomia ei löytynyt.'},
  all_locations: {defaultMessage: 'Kaikki lomakohteet'},
  all_locations_c: {defaultMessage: 'Kaikki kurssikohteet'},
  all_themes: {defaultMessage: 'Kaikki lomateemat'},
  all_themes_c: {defaultMessage: 'Kaikki kurssiteemat'},
  all_partners: {defaultMessage: 'Kaikki yhteistyökumppanit'},
  holiday_search: {defaultMessage: 'Lomahaku'},
  course_search: {defaultMessage: 'Kurssihaku'},
  date_format: {defaultMessage: 'pp.kk.vvvv'},
  invalid_date: {defaultMessage: 'Virheellinen päivämäärä.'},
  education: {defaultMessage: 'Koulutus'},
  NOTHING: {defaultMessage: 'Ei tutkintoa'},
  PRELIMINARY: {defaultMessage: 'Perusasteen koulutus'},
  MIDDLE_LEVEL: {defaultMessage: 'Keskiasteen koulutus (ammattikoulu, lukio)'},
  ACADEMIC: {defaultMessage: 'Korkea-asteen koulutus (AMK, yliopisto)'},
  union: {defaultMessage: 'Ammattiliitto'},
  no_union: {defaultMessage: 'En kuulu liittoon'},
  working_hours: {defaultMessage: 'Työaika'},
  FULL_TIME: {defaultMessage: 'Kokopäivätyö'},
  PART_TIME: {defaultMessage: 'Osa-aikatyö'},
  SHIFT_WORK: {defaultMessage: 'Vuorotyö'},
  LAYOFF: {defaultMessage: 'Lomautus'},
  STUDYING_BREAK: {defaultMessage: 'Opintovapaa'},
  JOB_ALTERNATION_LEAVE: {defaultMessage: 'Vuorotteluvapaa'},
  PARENTAL_LEAVE: {defaultMessage: 'Perhevapaa'},
  other_payer_info: {defaultMessage: 'Maksajan tiedot'},
  wishes_404: {defaultMessage: 'Lomatoiveita ei löytynyt.'},
  courses_404: {defaultMessage: 'Kurssitoiveita ei löytynyt.'},
  back_to_system: {defaultMessage: 'Palaa taustajärjestelmään'},
  back_to_calendar: {defaultMessage: 'Takaisin hakukalenteriin'},
  check_filter: {defaultMessage: 'Hakua ei voitu suorittaa, tarkista hakuehdot.'},
  date_in_past: {defaultMessage: 'Päivämäärä ei voi olla menneisyydessä.'},
  date_invalid: {defaultMessage: 'Päivämäärä on virheellinen.'},
  FRIEND: {defaultMessage: 'Ystävältä / sukulaiselta'},
  HOME_PAGE: {defaultMessage: 'Järjestön kotisivulta'},
  SOCIAL_MEDIA: {defaultMessage: 'Sosiaalisesta mediasta'},
  SOCIAL_WORK: {defaultMessage: 'Sosiaali-, perhe- tai diakoniatyön kautta'},
  PATIENT_ORGANIZATION: {defaultMessage: 'Järjestöltä / yhdistykseltä'},
  PAPER_MEDIA: {defaultMessage: 'Lehdestä'},
  change_date: {defaultMessage: 'valitse päivämäärä'},
  application_saved: {defaultMessage: 'Hakemus vastaanotettu'},
  application_saved2: {defaultMessage: 'Hakemuksesi on nyt vastaanotettu!'},
  identifier: {defaultMessage: 'Hakemus on tallennettu tunnisteella {identifier}.'},
  expand: {defaultMessage: 'laajenna'},
  displayed_rows: {defaultMessage: '{count} osumaa löytynyt, näytetään {from}-{to}'},
  next_page: {defaultMessage: 'seuraava sivu'},
  prev_page: {defaultMessage: 'edellinen sivu'},
  first_page: {defaultMessage: 'ensimmäinen sivu'},
  last_page: {defaultMessage: 'viimeinen sivu'},
  choose_holidays: {defaultMessage: 'Valitse 1-3 lomatoivetta hakeaksesi lomaa'},
  choose_courses: {defaultMessage: 'Valitse 1-3 kurssitoivetta hakeaksesi kurssille'},
  open_holiday: {defaultMessage: 'Lue lisää'},
  read_holiday: {defaultMessage: 'lomasta kohteessa {to}'},
  read_course: {defaultMessage: 'kurssista kohteessa {to}'},
  mark_primary: {defaultMessage: 'Ensisijaiseksi'},
  filters: {defaultMessage: 'Lomien suodatus'},
  filters_c: {defaultMessage: 'Kurssien suodatus'},
  wish_removed: {defaultMessage: 'Lomatoive poistettu.'},
  course_removed: {defaultMessage: 'Kurssitoive poistettu.'},
  wish_added: {defaultMessage: 'Lomatoive lisätty.'},
  course_added: {defaultMessage: 'Kurssitoive lisätty.'},
  email_not_matching: {defaultMessage: 'Sähköpostiosoitteet eivät vastaa toisiaan.'},
  email_again: {defaultMessage: 'Sähköpostiosoite uudelleen'},
  holiday_restrictions: {defaultMessage: 'Loman kohderyhmä'},
  course_restrictions: {defaultMessage: 'Kurssin kohderyhmä'},
  holiday_type: {defaultMessage: 'Millaista lomaa etsit?'},
  course_type: {defaultMessage: 'Millaista kurssia etsit?'},
  holidaytype_description: {defaultMessage: 'Valitse haetko aikuisten lomaa vai perhelomaa.'},
  coursetype_description: {defaultMessage: 'Valitse haetko aikuisten kurssia vai perhekurssia.'},
  holidays_select: {defaultMessage: 'Valittavissa olevat lomat'},
  courses_select: {defaultMessage: 'Valittavissa olevat kurssit'},
  adult_holidays: {defaultMessage: 'Aikuisten lomat'},
  adult_courses: {defaultMessage: 'Aikuisten kurssit'},
  family_holidays: {defaultMessage: 'Lapsiperhelomat'},
  family_courses: {defaultMessage: 'Lapsiperheiden kurssit'},
  choose: {defaultMessage: 'Valitse:'},
  wishes_full: {defaultMessage: 'Toiveet täynnä. Lomatoiveita voi lisätä enintään 3kpl.'},
  wishes_full_c: {defaultMessage: 'Toiveet täynnä. Kurssitoiveita voi lisätä enintään 3kpl.'},
  application_ended: {defaultMessage: 'Hakuaika on päättynyt'},
  save_pdf: {defaultMessage: 'Tallenna hakemus Pdf-muodossa'},
  save_error: {defaultMessage: 'Tallennuksessa tapahtui virhe. Ole hyvä ja yritä uudelleen hetken kuluttua.'},
  edit_header: {defaultMessage: 'Voit tässä muuttaa kentän otsikkoa ja ohjeistusta.'},
  edit_info_header: {defaultMessage: 'Voit tässä muuttaa sivun ohjeistusta'},
  edit_hint: {defaultMessage: 'Huomioithan, että muutokset vaikuttavat ainoastaan hakemuksen ulkoasuun. Et siis voi vaihtaa esimerkiksi kenttien järjestystä nimeämällä niitä uudelleen.'},
  lang_version: {defaultMessage: 'Järjestönne tarjoaa {count} eri kieliversiota, minkä takia käännökset ovat pakollisia.'},
  confirmations: {defaultMessage: 'Suostumukset'},
  option1: {defaultMessage: 'ei lainkaan tärkeää'},
  option2: {defaultMessage: 'vähän tärkeää'},
  option3: {defaultMessage: 'melko tärkeää'},
  option4: {defaultMessage: 'tärkeää'},
  option5: {defaultMessage: 'erittäin tärkeää'},
  option6: {defaultMessage: 'ei tavoitteena'},
  option7: {defaultMessage: 'erittäin huono'},
  option8: {defaultMessage: 'huono'},
  option9: {defaultMessage: 'ei hyvä eikä huono'},
  option10: {defaultMessage: 'hyvä'},
  option11: {defaultMessage: 'erinomainen'},
  objective_rest: {defaultMessage: 'Lepo ja virkistyminen'},
  objective_activity: {defaultMessage: 'Liikunnallisuus ja toiminta'},
  objective_support: {defaultMessage: 'Vertaistuki'},
  objective_social: {defaultMessage: 'Sosiaalinen kanssakäyminen'},
  objective_family: {defaultMessage: 'Perheen yhteinen aika'},
  objective_other: {defaultMessage: 'Muu tavoite'},
  situation_physical: {defaultMessage: 'Fyysinen terveys'},
  situation_mental: {defaultMessage: 'Psyykkinen terveys'},
  situation_social: {defaultMessage: 'Sosiaaliset suhteet'},
  situation_everyday: {defaultMessage: 'Arjen sujuminen'},
  situation_joy: {defaultMessage: 'Elämän mielekkyys'},
  situation_equality: {defaultMessage: 'Yhdenvertaisuuden kokemus'},
  cookie_title: {defaultMessage: 'Evästekäytäntö'},
  cookie_info: {defaultMessage: 'Eväste on pieni tekstitiedosto, jonka internet-selain tallentaa käyttäjän laitteelle. Evästeet asetetaan käyttäjän päätelaitteelle ainoastaan käyttäjän kutsuman sivuston mukana. Vain evästeen lähettänyt palvelin voi myöhemmin lukea ja käyttää evästettä. Evästeet tai muut tekniikat eivät vahingoita käyttäjän päätelaitetta tai tiedostoja, eikä evästeitä voi käyttää ohjelmien käyttämiseen tai haittaohjelmien levittämiseen. Käyttäjää ei voida tunnistaa pelkkien evästeiden avulla.'},
  cookie_read_more: {defaultMessage: 'Voit lukea lisää evästeistä ja Suomen evästevaatimuksista'},
  cookie_read_more_from: {defaultMessage: 'viestintäviraston verkkosivustolta'},
  cookie_law: {defaultMessage: 'Varaamme oikeuden päivittää evästekäytäntöjä esimerkiksi palveluiden kehityksen tai pakottavan lainsäädännön vuoksi.'},
  cookies: {defaultMessage: 'Sivustolla käytettävät evästeet:'},
  cookie_table: {defaultMessage: 'Käytettävät evästeet -taulu'},
  meaning: {defaultMessage: 'Tarkoitus'},
  cookies_use: {defaultMessage: 'Sivustomme käyttää evästeitä.'},
  cookies_read: {defaultMessage: 'lue lisää evästeistä.'},
  cookies_accept: {defaultMessage: 'Hyväksy evästeet painamalla nappia “Hyväksyn evästeet” tai'},
  cookies_accept_btn: {defaultMessage: 'Hyväksy evästeet'},
  cookie_session_id: {defaultMessage: 'Java-palvelinsivuja sisältävillä sivustoilla käytetty alustakohtainen istuntoeväste. Käyttäjän istunto pidetään anonyymina tämän evästeen avulla.'},
  cookie_oauth: {defaultMessage: 'Kirjautumistiedon eväste. Verkkosivuston ylläpitäjät voivat kirjautua sivustolle sisään käyttäen OAuth tunnistuspalvelua. Kirjautumisen tilasta pidetään kirjaa tämän evästeen avulla.'},
  accessibility_statement: {defaultMessage: 'Saavutettavuusseloste'},
  accessibility_welcome: {defaultMessage: 'Tervetuloa, tämä on organisaation {org} saavutettavuusseloste'},
  accessibility_info: {defaultMessage: 'Tämä saavutettavuusseloste koskee palvelua LOTU lomajärjestöjen sähköinen hakemus ja on laadittu 28.10.2021. Palvelua koskee laki digitaalisten palvelujen tarjoamisesta, jossa edellytetään, että julkisten verkkopalvelujen on oltava saavutettavia.'},
  accessibility_by: {defaultMessage: 'Olemme arvioineet palvelun saavutettavuuden itse'},
  accessibility_tested: {defaultMessage: 'Digipalvelun saavutettavuuden tila'},
  accessibility_result: {defaultMessage: 'Täyttää kaikki saavutettavuusvaatimukset.'},
  accessibility_deficiency: {defaultMessage: 'Huomasitko saavutettavuuspuutteen digipalvelussamme?'},
  accessibility_deficiency_inform: {defaultMessage: 'Kerro se meille ja teemme parhaamme puutteen korjaamiseksi'},
  accessibility_form: {defaultMessage: 'Verkkolomakkeella'},
  accessibility_form_fill: {defaultMessage: 'Täytä lomake täällä'},
  accessibility_email: {defaultMessage: 'Sähköpostilla'},
  accessibility_phone: {defaultMessage: 'Puhelimitse'},
  accessibility_official: {defaultMessage: 'Valvontaviranomainen'},
  accessibility_official_info: {defaultMessage: 'Jos huomaat sivustolla saavutettavuusongelmia, anna ensin palautetta meille eli sivuston ylläpitäjälle. Vastauksessa voi mennä 14 päivää. Jos et ole tyytyväinen saamaasi vastaukseen tai et saa vastausta lainkaan kahden viikon aikana, voit tehdä ilmoituksen'},
  accessibility_official_name: {defaultMessage: 'Etelä-Suomen aluehallintovirastoon.'},
  accessibility_official_info2: {defaultMessage: 'Etelä-Suomen aluehallintoviraston sivulla kerrotaan tarkasti, miten ilmoituksen voi tehdä ja miten asia käsitellään.'},
  accessibility_official_contact: {defaultMessage: 'Valvontaviranomaisen yhteystiedot'},
  accessibility_official_org: {defaultMessage: 'Etelä-Suomen aluehallintovirasto'},
  accessibility_official_unit: {defaultMessage: 'Saavutettavuuden valvonnan yksikkö'},
  accessibility_official_phone: {defaultMessage: 'puhelinnumero (vaihde) 0295 016 000'}
});
